﻿import { Accordion } from 'flowbite';

let hasLoadedGlobeModule = false;

// Check if element is in viewport
function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

// Your loadGlobeOnScroll function remains the same
function loadGlobeOnScroll() {
    const globeContainer = document.getElementById('globeContainer');
    const globePosition = globeContainer.getBoundingClientRect().top + window.scrollY;

    if (window.scrollY + window.innerHeight > globePosition - 500) {
        if (!hasLoadedGlobeModule) {
            hasLoadedGlobeModule = true;
            window.removeEventListener('scroll', loadGlobeOnScroll);

            import('./files/globeModule.js')
                .then(module => {
                    module.initializeGlobe(theme);
                })
                .catch(err => console.error('Error loading the globe module', err));
        }
    }
}

let globeContainer = document.getElementById('globeContainer');

// Check if globeContainer exists on the page
if (globeContainer) {
    // Check if globeContainer is in viewport when page loads
    if (isElementInViewport(globeContainer)) {
        hasLoadedGlobeModule = true;
        import('./files/globeModule.js')
            .then(module => {
                module.initializeGlobe(theme);
            })
            .catch(err => console.error('Error loading the globe module', err));
    } else {
        window.addEventListener('scroll', loadGlobeOnScroll);
    }
}

    const menuIcon = document.getElementById('menu-icon');
    const menuIconX = document.getElementById('menu-icon-x');
    const navbarToggle = document.querySelector('[data-collapse-toggle="navbar-default"]');

    function toggleMenuIcon() {
        const isNavbarOpen = navbarToggle.getAttribute('data-is-navbar-open');

        if (isNavbarOpen === 'true') {
            menuIcon.classList.remove('hidden');
            menuIconX.classList.add('hidden');
            navbarToggle.setAttribute('data-is-navbar-open', 'false');
        } else {
            menuIcon.classList.add('hidden');
            menuIconX.classList.remove('hidden');
            navbarToggle.setAttribute('data-is-navbar-open', 'true');
        }
    }

    navbarToggle.setAttribute('data-is-navbar-open', 'false');
    navbarToggle.addEventListener('click', toggleMenuIcon);

    const saveScrollPosition = () => {
        localStorage.setItem('scrollPosition', window.scrollY);
    };

    const themeSwitchButtons = document.querySelectorAll('button[name="theme"]');
    themeSwitchButtons.forEach(button => {
        button.addEventListener('click', saveScrollPosition);
    });

    const restoreScrollPosition = () => {
        const scrollPosition = localStorage.getItem('scrollPosition');
        if (scrollPosition) {
            window.scrollTo(0, parseInt(scrollPosition));
            localStorage.removeItem('scrollPosition');
        }
        document.body.classList.remove('hide-content');
    };

    restoreScrollPosition();

    const themeCookie = document.cookie.split('; ').find(row => row.startsWith('color-theme='));
    const theme = themeCookie ? themeCookie.split('=')[1] : 'light';

    const navBar = document.querySelector('nav');
    if (navBar) {
        navBar.classList.toggle('dark', theme === 'dark');
    }
    document.body.classList.toggle('dark', theme === 'dark');

   


